module.exports = __webpack_public_path__ + "static/media/sh.73751467.svg";